<script>
import { formatRelativeDate } from "../../utils/format-date-relative";
export default {
  name: "DialogNotification",
  components: {},
  data() {
    return {
      localShowDialogNotification: this.showDialogNotification,
      jointAddress: sessionStorage.getItem("jointAddress"),
      zetrixAccount: sessionStorage.getItem("zetrixAccount"),
      page: 1,
      pageSize: 6,
      notificationCount: 0,
      notificationList: [],
      totalPages: 0,
      totalElements: 0,
    };
  },
  async created() {
   // await this.countUnseenNotification();
    //await this.getNotificationList();
  },
  emits: ["update:showDialogNotification"],
  watch: {
    async showDialogNotification(newValue) {
      this.localShowDialogNotification = newValue;
    },
  },
  props: {
    showDialogNotification: Boolean,
  },
  methods: {
    closeNotification() {
      this.$emit("closeNotification");
    },

    async countUnseenNotification() {
      await this.$store
        .dispatch("notification/countNotification", {
          queryValue:
            "?userAddress=" + this.zetrixAccount + "&seen=false&type=MULTISIG",
        })
        .then((response) => {
          if (response != null) {
            this.notificationCount = response;
            sessionStorage.setItem("notification", this.notificationCount);
          }
        });
    },

    async getNotificationList() {
      await this.$store
        .dispatch("notification/getNotification", {
          queryValue:
            "?query=" +
            this.zetrixAccount +
            "&type=MULTISIG" +
            // "&remarks=" +
            // this.jointAddress +
            "&page=" +
            (this.page - 1) +
            "&pageSize=" +
            this.pageSize,
        })
        .then((response) => {
          if (response != null) {
            if (response.content.length > 0) {
              this.notificationList = response.content;
              this.totalPages = response.totalPages;
              this.totalElements = response.totalElements;
            } else {
              this.notificationList = [];
              this.totalPages = 0;
              this.totalElements = 0;
            }
            // this.$emit("updateNotificationList", this.notificationList);
          }
        });
    },

    // customed notification message
    navigateToWithParam(path, params) {
      this.$router.push({ path: `/${path}`, query: params });
    },

    async handleClick(item) {
      const blobId = this.getBlobId(item.remarks);
      this.updateSingleSeenNotification(item.id, item.seen);
      if (this.checkRemarks(item.remarks)) {
        // new notification data
        if (this.getPurposeNewNotification(item.content) === "UPDATE_ACCOUNT") {
          this.$router.push("/account/update/" + blobId);
        } else {
          // this.$router.push("/detail?blobId=" + blobId);
          this.$router.push({ path: "/detail", query: { blobId: blobId } });
          // this.navigateToWithParam("detail", { blobId: blobId });
        }
      } else {
        // old notification data
        if (this.getPurposeOldNotification(item.content) === "UPDATE_ACCOUNT") {
          this.$router.push("/account/update/" + blobId);
        } else {
          // this.$router.push("/detail?blobId=" + blobId);
          this.$router.push({ path: "/detail", query: { blobId: blobId } });
          // this.navigateToWithParam("detail", { blobId: blobId });
        }
      }
      await this.countUnseenNotification();
      //await this.getNotificationList();
    },

    notificationPage() {
      this.$router.push("/notification");
    },

    updateSingleSeenNotification(id, seen) {
      if (!seen) {
        this.$store
          .dispatch("notification/updateSeen", {
            pathValue: id,
            seen: true,
          })
          .then((response) => {
            return response;
          });
      }
    },

    getBlobId(inputString) {
      let array = inputString.split(",");
      return array[1];
    },

    getHash(inputString) {
      let array = inputString.split(",");
      return array[2];
    },

    formatDateToRelative(dateString) {
      return formatRelativeDate(dateString, "popup");
    },

    containsExecuted(str) {
      return (
        str.includes("successfully") ||
        str.includes("rejected") ||
        str.includes("failed")
      );
    },

    checkRemarks(remarksStr) {
      // check if notification content is from old data or new v2 data
      let array = remarksStr.split(",");
      return array.length > 2;
    },

    getPurposeOldNotification(contentStr) {
      if (contentStr.includes("TOKEN_TRANSFER")) {
        return "TOKEN_TRANSFER";
      } else if (contentStr.includes("UPDATE_ACCOUNT")) {
        return "UPDATE_ACCOUNT";
      } else if (contentStr.includes("SEND_ZTP20")) {
        return "SEND_ZTP20";
      } else if (contentStr.includes("UPGRADE_CONTRACT")) {
        return "UPGRADE_CONTRACT";
      } else if (contentStr.includes("CONTRACT")) {
        return "CONTRACT";
      } else if (contentStr.includes("CHANGE_OWNER")) {
        return "CHANGE_OWNER";
      } else {
        return "";
      }
    },

    formattedOldContent(contentStr, keyword) {
      const parts = this.splitOldContent(contentStr, keyword);
      return parts.join("");
    },

    splitOldContent(contentStr, keyword) {
      const parts = [];
      const regex = new RegExp(`(${keyword})`, "gi");
      const matches = contentStr.split(regex);

      matches.forEach((match) => {
        if (match.toLowerCase() === keyword.toLowerCase()) {
          parts.push(`<span class="content-purpose">${match}</span>`);
        } else {
          parts.push(match);
        }
      });

      return parts;
    },

    getPurposeNewNotification(contentStr) {
      if (contentStr.includes("ZETRIX")) {
        return "TOKEN_TRANSFER";
      } else if (contentStr.includes("Update")) {
        return "UPDATE_ACCOUNT";
      } else if (contentStr.includes("ZTP20")) {
        return "SEND_ZTP20";
      } else if (contentStr.includes("Invoke")) {
        return "CONTRACT";
      } else if (contentStr.includes("Upgrade")) {
        return "UPGRADE_CONTRACT";
      } else if (contentStr.includes("Change")) {
        return "CHANGE_OWNER";
      } else {
        return "";
      }
    },

    formattedNewContent(contentStr, keyword) {
      const parts = this.splitNewContent(contentStr, keyword);
      return parts.join("");
    },

    getKeywordNewContent(contentStr) {
      if (contentStr.includes("ZETRIX")) {
        return this.formattedNewContent(
          contentStr,
          "Send " + this.extractSendZetrixValue(contentStr) + " ZETRIX"
        );
      } else if (contentStr.includes("Update")) {
        return this.formattedNewContent(contentStr, "Update account details");
      } else if (contentStr.includes("ZTP20")) {
        return this.formattedNewContent(
          contentStr,
          "Send ZTP20 " + this.extractSendZTP20Value(contentStr)
        );
      } else if (contentStr.includes("Invoke")) {
        return this.formattedNewContent(contentStr, "Invoke contract");
      } else if (contentStr.includes("Upgrade")) {
        return this.formattedNewContent(contentStr, "Upgrade contract");
      } else if (contentStr.includes("Change")) {
        return this.formattedNewContent(contentStr, "Change contract owner");
      } else {
        return "";
      }
    },

    splitNewContent(contentStr, keyword) {
      const parts = [];
      const regex = new RegExp(`(${keyword})`, "gi");
      const matches = contentStr.split(regex);

      matches.forEach((match) => {
        if (match.toLowerCase() === keyword.toLowerCase()) {
          parts.push(`<span class="content-purpose">${match}</span>`);
        } else {
          parts.push(match);
        }
      });

      return parts;
    },

    extractSendZetrixValue(contentStr) {
      const regex = /Send\s+([\d.]+)\s+ZETRIX/;
      const match = contentStr.match(regex);

      return match ? match[1] : "";
    },

    extractSendZTP20Value(contentStr) {
      const regex = /ZTP20\s+([\d.]+\s+\w+)\s+(transaction|has)/;
      const match = contentStr.match(regex);

      return match ? match[1] : "";
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="localShowDialogNotification"
    width="512"
    @click.outside="closeNotification"
  >
    <v-card>
      <v-card-title class="pt-3">
        <v-badge
          v-if="notificationCount > 0"
          :content="notificationCount"
          inline
          offset-x="10"
          offset-y="10"
          class="badge-notification"
        >
          <b>Notifications</b> &nbsp; &nbsp;
        </v-badge>
        <b v-else>Notifications</b>
      </v-card-title>

      <!-- notification list -->
      <div v-if="notificationList.length > 0">
        <!-- <div v-for="(item, index) in notificationList" :key="index">
          <v-divider
            :thickness="1"
            class="border-opacity-50"
            :color="[!item.seen ? 'error' : '']"
          ></v-divider>
          <v-card
            :class="[
              'mx-auto-notification',
              !item.seen ? 'notification-unread' : '',
            ]"
            elevation="0"
          >
            <v-row class="notification-row">
              <v-col col="12" sm="1" md="1" lg="1" class="notification-icon">
                <v-icon class="primary-icon">mdi-currency-usd</v-icon>
              </v-col>
              <v-col col="12" sm="8" md="8" lg="8" class="notification-message">
                <b>
                  <span class="primary-icon">Send 0.002 ZETRIX</span> has been
                  approved. You have a pending transaction that needs execution.
                </b>
              </v-col>
              <v-col col="12" sm="3" md="3" lg="3" class="notification-time">
                <b class="notification-time-text">
                  {{ formatDateToRelative(item.createdAt) }}
                </b>
              </v-col>
            </v-row>
          </v-card>
          <v-divider
            :thickness="1"
            class="border-opacity-50"
            :color="[!item.seen ? 'error' : '']"
          ></v-divider>
        </div> -->
        <div v-for="(item, index) in notificationList" :key="index">
          <v-divider
            :thickness="1"
            class="border-opacity-50"
            :color="!item.seen ? 'error' : ''"
          ></v-divider>
          <v-card
            link
            @click="handleClick(item)"
            :class="[
              'mx-auto-notification',
              !item.seen ? 'notification-unread' : '',
            ]"
            elevation="0"
          >
            <div class="tx-container notification-container">
              <v-row>
                <v-col cols="12" md="1" lg="1">
                  <span
                    v-if="checkRemarks(item.remarks)"
                    style="margin-right: 10px"
                  >
                    <v-icon
                      v-if="
                        getPurposeNewNotification(item.content) ===
                        'TOKEN_TRANSFER'
                      "
                      icon="mdi-currency-usd"
                      color="#C22328"
                      style="padding-bottom: 6px; padding-top: 6px"
                    ></v-icon>
                    <v-icon
                      v-else-if="
                        getPurposeNewNotification(item.content) ===
                        'UPDATE_ACCOUNT'
                      "
                      icon="mdi-account-multiple-outline"
                      color="#C22328"
                      style="padding-bottom: 6px; padding-top: 6px"
                    ></v-icon>
                    <v-icon
                      v-else
                      icon="mdi-file-document-outline"
                      color="#C22328"
                      style="padding-bottom: 6px; padding-top: 6px"
                    ></v-icon>
                  </span>
                  <span v-else style="margin-right: 10px">
                    <v-icon
                      v-if="
                        getPurposeOldNotification(item.content) ===
                        'TOKEN_TRANSFER'
                      "
                      icon="mdi-currency-usd"
                      color="#C22328"
                      style="padding-bottom: 6px; padding-top: 6px"
                    ></v-icon>
                    <v-icon
                      v-else-if="
                        getPurposeOldNotification(item.content) ===
                        'UPDATE_ACCOUNT'
                      "
                      icon="mdi-account-multiple-outline"
                      color="#C22328"
                      style="padding-bottom: 6px; padding-top: 6px"
                    ></v-icon>
                    <v-icon
                      v-else
                      icon="mdi-file-document-outline"
                      color="#C22328"
                      style="padding-bottom: 6px; padding-top: 6px"
                    ></v-icon>
                  </span>
                </v-col>
                <v-col cols="12" md="8" lg="8">
                  <span v-if="checkRemarks(item.remarks)">
                    <span v-html="getKeywordNewContent(item.content)"></span>
                  </span>
                  <span v-else>
                    <span
                      v-html="
                        formattedOldContent(
                          item.content,
                          getPurposeOldNotification(item.content)
                        )
                      "
                    >
                    </span>
                  </span>
                </v-col>
                <v-col cols="12" md="3" lg="3" style="text-align: right">
                  <p>
                    {{ formatDateToRelative(item.createdAt) }}
                  </p>
                </v-col>
              </v-row>
            </div>
            <!-- <div
              class="spacer tx-container notification-container"
              v-else-if="isTabletScreen"
            >
              <div style="flex-shrink: 0">
                <span v-if="checkRemarks(item.remarks)">
                  <v-icon
                    v-if="
                      getPurposeNewNotification(item.content) ===
                      'TOKEN_TRANSFER'
                    "
                    icon="mdi-currency-usd"
                    color="#C22328"
                    style="padding-bottom: 6px; padding-top: 6px"
                  ></v-icon>
                  <v-icon
                    v-else-if="
                      getPurposeNewNotification(item.content) ===
                      'UPDATE_ACCOUNT'
                    "
                    icon="mdi-account-multiple-outline"
                    color="#C22328"
                    style="padding-bottom: 6px; padding-top: 6px"
                  ></v-icon>
                  <v-icon
                    v-else
                    icon="mdi-file-document-outline"
                    color="#C22328"
                    style="padding-bottom: 6px; padding-top: 6px"
                  ></v-icon>
                </span>
                <span v-else>
                  <v-icon
                    v-if="
                      getPurposeOldNotification(item.content) ===
                      'TOKEN_TRANSFER'
                    "
                    icon="mdi-currency-usd"
                    color="#C22328"
                    style="padding-bottom: 6px; padding-top: 6px"
                  ></v-icon>
                  <v-icon
                    v-else-if="
                      getPurposeOldNotification(item.content) ===
                      'UPDATE_ACCOUNT'
                    "
                    icon="mdi-account-multiple-outline"
                    color="#C22328"
                    style="padding-bottom: 6px; padding-top: 6px"
                  ></v-icon>
                  <v-icon
                    v-else
                    icon="mdi-file-document-outline"
                    color="#C22328"
                    style="padding-bottom: 6px; padding-top: 6px"
                  ></v-icon>
                </span>
              </div>
              <div style="margin-left: 10px">
                <v-row>
                  <v-col cols="12" sm="10">
                    <span v-if="checkRemarks(item.remarks)">
                      <span v-html="getKeywordNewContent(item.content)"></span>
                    </span>
                    <span v-else>
                      <span
                        v-html="
                          formattedOldContent(
                            item.content,
                            getPurposeOldNotification(item.content)
                          )
                        "
                      >
                      </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <p style="color: #515a5a">
                      {{ formatDateToRelative(item.createdAt) }}
                    </p>
                  </v-col>
                </v-row>
                <div class="remarks-text" style="padding-top: 10px">
                  <p>
                    <span class="remark-title" style="font-size: 12px">
                      BLOB
                    </span>
                    <span class="remark-value" style="font-size: 12px">
                      {{ getBlobId(item.remarks) }}
                    </span>
                  </p>
                  <p v-if="containsExecuted(item.content)">
                    <span class="remark-title" style="font-size: 12px">
                      HASH
                    </span>
                    <span class="remark-value" style="font-size: 12px">
                      {{ getHash(item.remarks) }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div v-else class="spacer tx-container notification-container">
              <div style="flex-shrink: 0">
                <span v-if="checkRemarks(item.remarks)">
                  <v-icon
                    v-if="
                      getPurposeNewNotification(item.content) ===
                      'TOKEN_TRANSFER'
                    "
                    icon="mdi-currency-usd"
                    color="#C22328"
                    style="padding-bottom: 6px; padding-top: 6px"
                  ></v-icon>
                  <v-icon
                    v-else-if="
                      getPurposeNewNotification(item.content) ===
                      'UPDATE_ACCOUNT'
                    "
                    icon="mdi-account-multiple-outline"
                    color="#C22328"
                    style="padding-bottom: 6px; padding-top: 6px"
                  ></v-icon>
                  <v-icon
                    v-else
                    icon="mdi-file-document-outline"
                    color="#C22328"
                    style="padding-bottom: 6px; padding-top: 6px"
                  ></v-icon>
                </span>
                <span v-else>
                  <v-icon
                    v-if="
                      getPurposeOldNotification(item.content) ===
                      'TOKEN_TRANSFER'
                    "
                    icon="mdi-currency-usd"
                    color="#C22328"
                    style="padding-bottom: 6px; padding-top: 6px"
                  ></v-icon>
                  <v-icon
                    v-else-if="
                      getPurposeOldNotification(item.content) ===
                      'UPDATE_ACCOUNT'
                    "
                    icon="mdi-account-multiple-outline"
                    color="#C22328"
                    style="padding-bottom: 6px; padding-top: 6px"
                  ></v-icon>
                  <v-icon
                    v-else
                    icon="mdi-file-document-outline"
                    color="#C22328"
                    style="padding-bottom: 6px; padding-top: 6px"
                  ></v-icon>
                </span>
              </div>
              <div style="margin-left: 10px">
                <span v-if="checkRemarks(item.remarks)">
                  <span v-html="getKeywordNewContent(item.content)"></span>
                </span>
                <span v-else>
                  <span
                    v-html="
                      formattedOldContent(
                        item.content,
                        getPurposeOldNotification(item.content)
                      )
                    "
                  >
                  </span>
                </span>
                <p style="font-size: 14px; color: #515a5a">
                  {{ formatDateToRelative(item.createdAt) }}
                </p>
              </div>
            </div> -->
          </v-card>
          <v-divider
            :thickness="1"
            class="border-opacity-50"
            :color="!item.seen ? 'error' : ''"
          ></v-divider>
        </div>
      </div>
      <div v-else>
        <v-card elevation="0" class="text-center">No notification yet</v-card>
      </div>
      <!-- mdi-currency-usd
      mdi-file-document-outline
      mdi-account-multiple-outline -->
      <!-- notification list -->

      <v-card-actions class="pa-5 primary-icon justify-center">
        <button v-if="notificationList.length > 0" @click="notificationPage">
          <b>See all notifications</b>
        </button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style>
.v-dialog > .v-overlay__content > .v-card,
.v-dialog > .v-overlay__content > .v-sheet,
.v-dialog > .v-overlay__content > form > .v-card,
.v-dialog > .v-overlay__content > form > .v-sheet {
  border-radius: 15px;
}

.badge-notification > .v-badge__wrapper > .v-badge__badge {
  border-radius: 5px;
  background: var(--v-primary-gradient) !important;
  color: white !important;
}

/* dialog notification */
.v-card {
  border-radius: 0px;
}

.mx-auto-notification {
  margin-right: 0px;
  margin-left: 0px;
  width: -webkit-fill-available;
  padding: 10px;
  border-radius: 0px;
}

.notification-row {
  padding-left: 15px;
  padding-right: 15px;
}

.notification-icon {
  padding-right: 0px;
  /* text-align: end; */
}

.notification-message {
  padding-left: 0px;
  text-align: start;
}

.notification-time {
  text-align: end;
}

.notification-time-text {
  color: #515a5a;
}

.v-card.notification-unread {
  background: #ffe6e4;
  border-radius: 0px;
}
</style>
